module.exports = __webpack_public_path__ + "static/img/2.6513a80.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/2/eng/2.png
// module id = p/FR
// module chunks = 0